import React from "react";
import ProtectedRoute from "../ProtectedRoute";
import WorkspaceGuard from "../WorkspaceGuard/WorkspaceGuard";
import AppShell from "./AppShell";

const ProtectedAppRoute = ({ component: Component }) => (
  <ProtectedRoute>
    <WorkspaceGuard>
      <AppShell>
        <Component />
      </AppShell>
    </WorkspaceGuard>
  </ProtectedRoute>
);

export default ProtectedAppRoute;
